import { render, staticRenderFns } from "./APlaceEntityType.vue?vue&type=template&id=d748147a"
import script from "./APlaceEntityType.vue?vue&type=script&lang=js"
export * from "./APlaceEntityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports